<h2 mat-dialog-title class="title-small">Give Access to {{ data.name }} {{ data.surname }}</h2>
<mat-dialog-content class="mat-typography" style="padding-top: 10px;">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">

        <!-- Start Date and Time -->
        <div fxLayout="row" fxLayoutGap="16px">
            <div fxFlex fxLayout="column" fxLayoutGap="7px">
                <span class="body-1-regular-2" style="font-size: 11px;">Start Date</span>
                <mat-form-field appearance="outline" class="custom-date-picker" style="width: 100%;">
                    <input matInput [matDatepicker]="startPicker" formControlName="startDate" placeholder="Select date">
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                </mat-form-field>
            </div>

            <div fxFlex fxLayout="column" fxLayoutGap="7px">
                <span class="body-1-regular-2" style="font-size: 11px;">Start Time</span>
                <mat-form-field appearance="outline" class="custom-select-field custom-time-field" style="width: 100%;">
                    <input matInput type="time" formControlName="startTime">
                </mat-form-field>
            </div>
        </div>

        <!-- End Date and Time -->
        <div fxLayout="row" fxLayoutGap="16px">
            <div fxFlex fxLayout="column" fxLayoutGap="7px">
                <span class="body-1-regular-2" style="font-size: 11px;">End Date</span>
                <mat-form-field appearance="outline" class="custom-date-picker" style="width: 100%;">
                    <input matInput [matDatepicker]="endPicker" formControlName="endDate" placeholder="Select date">
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                </mat-form-field>
            </div>

            <div fxFlex fxLayout="column" fxLayoutGap="7px">
                <span class="body-1-regular-2" style="font-size: 11px;">End Time</span>
                <mat-form-field appearance="outline" class="custom-select-field custom-time-field" style="width: 100%;">
                    <input matInput type="time" formControlName="endTime">
                </mat-form-field>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 16px 24px;">
    <button mat-button (click)="onCancel()" class="body-1-regular-2">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">Give Access</button>
</mat-dialog-actions>
